const checkValidValues = ({
  toCheck,
  optionalKeys,
  requiredKeys,
}: {
  toCheck: Dict;
  optionalKeys?: string[];
  requiredKeys?: string[];
}) => {
  let processedRequiredKeys = 0;
  for (const [key, value] of Object.entries(toCheck)) {
    if (optionalKeys && optionalKeys.includes(key)) {
      continue;
    }

    if (requiredKeys && requiredKeys.includes(key)) {
      processedRequiredKeys++;
    }

    if (!value && !optionalKeys?.includes(key)) {
      return false;
    }
  }

  if (requiredKeys && processedRequiredKeys !== requiredKeys.length) {
    return false;
  }

  return true;
};

export default checkValidValues;
